var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsInput(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 20,
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4396_28271",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 15,
    height: 15
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 2,
    width: 15,
    height: 15,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4396_28271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.78125 15.75L6.53125 13.75C6.39583 13.6979 6.26823 13.6354 6.14844 13.5625C6.02865 13.4896 5.91146 13.4115 5.79688 13.3281L3.9375 14.1094L2.21875 11.1406L3.82812 9.92188C3.81771 9.84896 3.8125 9.77865 3.8125 9.71094V9.28906C3.8125 9.22135 3.81771 9.15104 3.82812 9.07812L2.21875 7.85938L3.9375 4.89062L5.79688 5.67188C5.91146 5.58854 6.03125 5.51042 6.15625 5.4375C6.28125 5.36458 6.40625 5.30208 6.53125 5.25L6.78125 3.25H10.2188L10.4688 5.25C10.6042 5.30208 10.7318 5.36458 10.8516 5.4375C10.9714 5.51042 11.0885 5.58854 11.2031 5.67188L13.0625 4.89062L14.7812 7.85938L13.1719 9.07812C13.1823 9.15104 13.1875 9.22135 13.1875 9.28906V9.71094C13.1875 9.77865 13.1771 9.84896 13.1562 9.92188L14.7656 11.1406L13.0469 14.1094L11.2031 13.3281C11.0885 13.4115 10.9688 13.4896 10.8438 13.5625C10.7188 13.6354 10.5938 13.6979 10.4688 13.75L10.2188 15.75H6.78125ZM8.53125 11.6875C9.13542 11.6875 9.65104 11.474 10.0781 11.0469C10.5052 10.6198 10.7188 10.1042 10.7188 9.5C10.7188 8.89583 10.5052 8.38021 10.0781 7.95312C9.65104 7.52604 9.13542 7.3125 8.53125 7.3125C7.91667 7.3125 7.39844 7.52604 6.97656 7.95312C6.55469 8.38021 6.34375 8.89583 6.34375 9.5C6.34375 10.1042 6.55469 10.6198 6.97656 11.0469C7.39844 11.474 7.91667 11.6875 8.53125 11.6875Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsInput);
export default __webpack_public_path__ + "static/media/settings-input.bd62281d3c47d59278160a833054ba0d.svg";
export { ForwardRef as ReactComponent };